if ($.isFunction($.fn.slick)) {

    $('.tours__slider, .packages__slider, .testimonials__slider, .posts__slider, .boats__slider, .events__slider, .activities__slider').each(function () {
        let $slider = $(this),
            sliderClass = $(this).attr('class');

        $slider.slick({
            rows: 0,
            arrows: true,
            prevArrow: '<a href="#" class="slick-control slick-control--prev" title="Vorige" data-gtm-event="'+ sliderClass +' control previous" rel="nofollow"><i class="far fa-angle-left"></i></a>',
            nextArrow: '<a href="#" class="slick-control slick-control--next" title="Volgende" data-gtm-event="'+ sliderClass +' control next" rel="nofollow"><i class="far fa-angle-right"></i></a>',
            dots: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            speed: 500,
            infinite: false,
            swipeToSlide: true,
            lazyLoad: 'ondemand',
            customPaging: function (slick, index) {
                return '<button type="button" id="slick-dot-' + index + '" class="slick-dot" rel="nofollow"></button>';
            },
            responsive: [{
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2
                }
            }, {
                breakpoint: 580,
                settings: {
                    slidesToShow: 1,
                    adaptiveHeight: true
                }
            }]
        });

        // moving sliders when item that is not active is clicked
        $slider.on( 'click', '.slick-slide', function(e) {
            if (!$(this).hasClass('slick-active')) {
                e.preventDefault();

                // check if slide is before or after active slides
                if ($(this).prevAll('.slick-active').length > 0) {
                    // console.log('element comes after active');
                    $slider.slick('slickNext');
                } else {
                    // console.log('element comes before active');
                    $slider.slick('slickPrev');
                }
            }
        });
    });

    $('.logos__slider').each(function () {
        let $slider = $(this),
            totalSlides = $slider.find('.slide').length - 1;

        $slider.slick({
            rows: 0,
            arrows: true,
            prevArrow: '<a href="#" class="slick-control slick-control--prev" title="Vorige" data-gtm-event="Logos slider control: previous" rel="nofollow"><i class="far fa-angle-left"></i></a>',
            nextArrow: '<a href="#" class="slick-control slick-control--next" title="Volgende" data-gtm-event="Logos slider control: next" rel="nofollow"><i class="far fa-angle-right"></i></a>',
            dots: false,
            slidesToShow: totalSlides >= 7 ? 7 : totalSlides, // show 7, or less if less than 7 slides exist
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            speed: 1000,
            centerMode: true,
            centerPadding: '0px',
            swipeToSlide: true,
            variableWidth: true,
            responsive: [{
                breakpoint: 1400,
                settings: {
                    slidesToShow: totalSlides >= 5 ? 5 : totalSlides
                }
            }, {
                breakpoint: 768,
                settings: {
                    slidesToShow: totalSlides >= 3 ? 3 : totalSlides
                }
            }]
        });
    });

    $('.gallery').each(function() {
        let $slider = $('.gallery__slider', this),
            $thumbs = $('.gallery__thumbs', this),
            $counter = $('.gallery__counter', this);

        $slider.on('afterChange', function() {
            if ($counter.length > 0) {
                $counter.find('.current').text($slider.find('.slick-current').data('slick-index') + 1);
            }
        }).slick({
            asNavFor: $thumbs,
            rows: 0,
            arrows: true,
            prevArrow: '<a href="#" class="slick-control slick-control--prev" data-gtm-event="Gallery slider control: previous" rel="nofollow"><i class="far fa-angle-left"></i></a>',
            nextArrow: '<a href="#" class="slick-control slick-control--next" data-gtm-event="Gallery slider control: next" rel="nofollow"><i class="far fa-angle-right"></i></a>',
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 1000,
            infinite: false,
            adaptiveHeight: true,
            lazyLoad: 'ondemand',
        });

        $thumbs.slick({
            asNavFor: $slider,
            rows: 0,
            arrows: false,
            dots: false,
            slidesToShow: 7,
            slidesToScroll: 1,
            speed: 1000,
            infinite: false,
            swipeToSlide: true,
            focusOnSelect: true,
            lazyLoad: 'ondemand',
            responsive: [{
                breakpoint: 768,
                settings: {
                    slidesToShow: 6
                }
            },{
                breakpoint: 580,
                settings: {
                    slidesToShow: 5
                }
            },{
                breakpoint: 400,
                settings: {
                    slidesToShow: 4
                }
            }]
        });

        if ($counter.length > 0) {
            $counter.find('.total').text($slider.find('.slide:not(.slick-cloned)').length);
        }
    });

    initImageGallerySlider();
    $(window).on('resize', initImageGallerySlider);

    // this slider is only visible on mobile, init via function so slick will work after window resize as well
    function initImageGallerySlider() {
        if (viewport().width < 768) {
            $('.image-gallery__slider:not(.slick-initialized)').slick({ // only init when not already initialized
                rows: 0,
                arrows: true,
                prevArrow: '<a href="#" class="slick-control slick-control--prev" data-gtm-event="Event gallery slider control: previous" rel="nofollow"><i class="far fa-angle-left"></i></a>',
                nextArrow: '<a href="#" class="slick-control slick-control--next" data-gtm-event="Event gallery slider control: next" rel="nofollow"><i class="far fa-angle-right"></i></a>',
                dots: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                infinite: true,
                lazyLoad: 'ondemand',
                customPaging: function (slick, index) {
                    return '<button type="button" id="slick-dot-' + index + '" class="slick-dot" rel="nofollow"></button>';
                },
            });
        }
    }

    $('.section__background-slider').each(function () {
        let $slider = $(this);

        $slider.slick({
            rows: 0,
            arrows: false,
            dots: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 3000,
            speed: 1000,
            fade: true
        });
    });

    $('.content-image-blocks .block__slider').each(function () {
        let $slider = $(this),
            sliderClass = $(this).attr('class');

        $slider.slick({
            rows: 0,
            arrows: true,
            prevArrow: '<a href="#" class="slick-control slick-control--prev" title="Vorige" data-gtm-event="'+ sliderClass +' control previous" rel="nofollow"><i class="far fa-angle-left"></i></a>',
            nextArrow: '<a href="#" class="slick-control slick-control--next" title="Volgende" data-gtm-event="'+ sliderClass +' control next" rel="nofollow"><i class="far fa-angle-right"></i></a>',
            dots: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 1000,
            fade: true,
            adaptiveHeight: true,
            infinite: true,
            lazyLoad: 'ondemand',
            customPaging: function (slick, index) {
                return '<button type="button" id="slick-dot-' + index + '" class="slick-dot" rel="nofollow"></button>';
            },
        });
    });

} else {
    console.log('.slick() is not a function');
}